import { render, staticRenderFns } from "./LgFinderPageOrnograma.vue?vue&type=template&id=9969cb5c&scoped=true"
import script from "./LgFinderPageOrnograma.vue?vue&type=script&lang=js"
export * from "./LgFinderPageOrnograma.vue?vue&type=script&lang=js"
import style0 from "./LgFinderPageOrnograma.vue?vue&type=style&index=0&id=9969cb5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9969cb5c",
  null
  
)

export default component.exports